module.exports = __webpack_public_path__ + "img/Bocaux_en_verre_de_mariage.38f9d46.jpg";